/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { fastAccessViewGetOrganisationFastAccessView } from '../fn/fast-access-view/fast-access-view-get-organisation-fast-access-view';
import { FastAccessViewGetOrganisationFastAccessView$Params } from '../fn/fast-access-view/fast-access-view-get-organisation-fast-access-view';
import { fastAccessViewGetVaultFastAccessView } from '../fn/fast-access-view/fast-access-view-get-vault-fast-access-view';
import { FastAccessViewGetVaultFastAccessView$Params } from '../fn/fast-access-view/fast-access-view-get-vault-fast-access-view';
import { OrganisationFastAccessView } from '../models/organisation-fast-access-view';
import { VaultFastAccessView } from '../models/vault-fast-access-view';

@Injectable({ providedIn: 'root' })
export class FastAccessViewService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fastAccessViewGetOrganisationFastAccessView()` */
  static readonly FastAccessViewGetOrganisationFastAccessViewPath = '/fast-access-view/organisation';

  /**
   * Get fast access view for organisation.
   *
   * Get fast access view for organisation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fastAccessViewGetOrganisationFastAccessView()` instead.
   *
   * This method doesn't expect any request body.
   */
  fastAccessViewGetOrganisationFastAccessView$Response(params?: FastAccessViewGetOrganisationFastAccessView$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganisationFastAccessView>> {
    const obs = fastAccessViewGetOrganisationFastAccessView(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get fast access view for organisation.
   *
   * Get fast access view for organisation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fastAccessViewGetOrganisationFastAccessView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fastAccessViewGetOrganisationFastAccessView(params?: FastAccessViewGetOrganisationFastAccessView$Params, context?: HttpContext): Observable<OrganisationFastAccessView> {
    const resp = this.fastAccessViewGetOrganisationFastAccessView$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganisationFastAccessView>): OrganisationFastAccessView => r.body)
    );
  }

  /** Path part for operation `fastAccessViewGetVaultFastAccessView()` */
  static readonly FastAccessViewGetVaultFastAccessViewPath = '/fast-access-view/vault/{vaultId}';

  /**
   * Get fast access view for vault.
   *
   * Get fast access view for vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fastAccessViewGetVaultFastAccessView()` instead.
   *
   * This method doesn't expect any request body.
   */
  fastAccessViewGetVaultFastAccessView$Response(params: FastAccessViewGetVaultFastAccessView$Params, context?: HttpContext): Observable<StrictHttpResponse<VaultFastAccessView>> {
    const obs = fastAccessViewGetVaultFastAccessView(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get fast access view for vault.
   *
   * Get fast access view for vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fastAccessViewGetVaultFastAccessView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fastAccessViewGetVaultFastAccessView(params: FastAccessViewGetVaultFastAccessView$Params, context?: HttpContext): Observable<VaultFastAccessView> {
    const resp = this.fastAccessViewGetVaultFastAccessView$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VaultFastAccessView>): VaultFastAccessView => r.body)
    );
  }

}
